module.exports = __webpack_public_path__ + "img/logo.e0ee6fe0.jpg";